import { extend, override } from "flarum/extend";
import HeaderSecondary from "flarum/forum/components/HeaderSecondary";
import SignUpModal from "flarum/forum/components/SignUpModal";
import extractText from 'flarum/common/utils/extractText';
import LinkButton from 'flarum/common/components/LinkButton';
import LogInModal from 'flarum/forum/components/LogInModal';
import UserSecurityPage from 'flarum/forum/components/UserSecurityPage';

app.initializers.add('bj-community/my-bj-auth', (app) => {
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;  // Return null if the cookie doesn't exist
    }

    // Example usage
    const access_token = getCookie('mybje_access_token');
    extend(HeaderSecondary.prototype, "items", function (items) {
        const logout = '/logout';
        if (app.forum && app.forum.attribute('showPanel')) {
            items.replace(
                "session",
                <div class="mybje-panel text-capitalize" data-mybje-panel-locale="de"
                     data-mybje-panel-link-href="/"
                     data-mybje-panel-access-token={access_token}
                     data-mybje-panel-logout-href={logout} data-mybje-panel-template-version="3"
                     data-mybje-panel-client-id={app.forum.attribute('oauthId')}>
                  <span id="Panel-Button-Mobile" class="Panel-Button-Mobile">myBUSCH-JAEGER</span>
                </div>
            )

            if (app.session.user) {
                items.add("settings",
                  <div className={"ButtonGroup Dropdown dropdown"}>
                    <LinkButton className={"Dropdown-toggle Button Button--flat"} href={app.route('settings')} icon="fas fa-cog" title={"Einstellungen"}>
                      Einstellungen
                    </LinkButton>
                  </div>
                )
            }
        }

      const host = app.forum.attribute('mybjeHost') + '/de/user/registration'
      items.replace(
        "signUp",
        <button className={"Button Button--link"}>
          <a href={host} className={"Button-label"} target={"_self"}>
                    {app.translator.trans("core.forum.header.sign_up_link")}
                </a>
            </button>
        );
    });

    extend(UserSecurityPage.prototype, "settingsItems", function (items) {
      items.remove('linkedAccounts')
    });

    extend(SignUpModal.prototype, "fields", function (items) {
        items.remove('username-help')
        items.remove('email')
        items.add(
            'nickname',
            <div className="Form-group">
                <label>{app.translator.trans('fof-oauth.forum.nickname.choose')}</label>
                <input
                    className="FormControl"
                    name="nickname"
                    type="text"
                    placeholder={extractText(app.translator.trans('flarum-nicknames.forum.sign_up.nickname_placeholder'))}
                    bidi={this.nickname}
                    disabled={this.loading || this.isProvided('nickname')}
                    required={app.forum.attribute('randomizeUsernameOnRegistration')}
                />
            </div>,
            25
        );

        items.replace('username', <input type={"hidden"} name={"username"} value={this.attrs.username}/>)
    });

    override(SignUpModal.prototype, 'footer', function (original) {
      return [];
    });

    document.addEventListener('DOMContentLoaded', function () {
        const host = app.forum.attribute('mybjeHost')
        var mybje_panel_sdk_src = host + "/api/panel/js";

        (function(d, url) {
            var id = 'mybje_panel_sdk_src';
            if ( d.getElementById(id) ) return;
            var s = 'script', p = d.getElementsByTagName(s)[0], js = d.createElement(s); js.id = id; js.src = url;
            p.parentNode.insertBefore(js, p);
        })(document, mybje_panel_sdk_src);
    });

    window.addEventListener("load", (event) => {
      const panelTextTrigger = document.getElementById('Panel-Button-Mobile');
      const panelTrigger = document.getElementsByClassName('c-mybje-panel-trigger')[0];

      if (panelTrigger) {
        panelTrigger.appendChild(panelTextTrigger)
      }
    });

    override(LogInModal.prototype, 'oninit', function (original) {
        app.modal.close();
        window.open(
          app.forum.attribute('baseUrl') + '/auth/passport',
          'logInPopup',
          'status=no,scrollbars=yes,resizable=no'
        );
    });
});
